class ProductFormSelectors extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("change", () => this.handleInputChange());
    this.addEventListener("pdp-variant-button:updated", () => {
      this.data = window.scrapeSectionData(this);

      const variant = this.findMatchingVariant();

      if (variant) {
        this.updateGroupedProductUrls(variant);
      }
    });
  }

  disconnectedCallback() {}

  findMatchingVariant() {
    if (!this.data) {
      this.data = window.scrapeSectionData(this);
    }

    const form = this.closest("form");
    const productOptionsCount = Number(this.data?.productOptionsCount);

    if (
      !form ||
      !Number.isInteger(productOptionsCount) ||
      productOptionsCount < 1 ||
      !Array.isArray(this.data?.optionsByVariant) ||
      !Array.isArray(this.data?.variants)
    ) {
      return null;
    }

    const selectedOptionValueIds = new Array(productOptionsCount)
      .fill(null)
      .map((_, i) => parseInt(form[`option-${i + 1}`]?.value, 10));

    const matchingVariant = this.data.optionsByVariant.find((variant) =>
      selectedOptionValueIds.every((selectedOptionValueId, i) => {
        return (
          Number.isInteger(selectedOptionValueId) &&
          selectedOptionValueId === variant?.variantOptions?.[i]?.id
        );
      }),
    );

    let variant = null;

    if (matchingVariant) {
      variant = this.data.variants.find(
        (variant) => variant.id === matchingVariant.variantId,
      );
    }

    return variant;
  } 

  updateGroupedProductUrls(selectedVariant) {
    if (!this.data) {
      this.data = window.scrapeSectionData(this);
    }

    if (!Array.isArray(selectedVariant?.options)) return;

    this.querySelectorAll("pdp-variant-button").forEach((variantButton) => {
      const optionIndex = parseInt(variantButton.dataset.optionIndex, 10);
      if (!Number.isInteger(optionIndex)) return;

      const optionsToMatch = [...selectedVariant.options];
      optionsToMatch[optionIndex] = null;

      const targetProductId = variantButton.dataset.productId;
      const targetProductVariantData =
        this.data?.combinedListingProductVariantData?.[targetProductId];
      if (!Array.isArray(targetProductVariantData)) return;

      const similarVariant = targetProductVariantData.find((variant) =>
        variant?.options?.every(
          (optionValue, i) =>
            optionValue === optionsToMatch[i] || optionsToMatch[i] === null,
        ),
      );

      if (similarVariant) {
        variantButton.setAttribute("product-url", similarVariant.variant_url);
      }
    });
  }

  handleInputChange() {
    this.data = window.scrapeSectionData(this);

    const variant = this.findMatchingVariant();

    if (variant) {
      this.updateGroupedProductUrls(variant);
      this.updateSelectedOptionLabels(variant);
    }

    this.dispatchEvent(
      new CustomEvent("variant:changed", {
        bubbles: true,
        detail: { variant },
      }),
    );
  }

  updateSelectedOptionLabels(variant) {
    const groups = this.querySelectorAll(".variant-buttons");
    (variant.options || []).forEach((valueName, index) => {
      const selectedSpan = groups[index]?.querySelector(".variant-buttons__selected");
      if (selectedSpan) selectedSpan.textContent = valueName;
    });
  }
}

if (!customElements.get("product-form-selectors")) {
  customElements.define("product-form-selectors", ProductFormSelectors);
}
